const debounce = require('lodash/debounce');
const { types, default: store } = require('../vue/store');
const { default: getFrontConfig } = require('../common/getFrontConfig');

const {
  searchAI: {
    isEnabledInFront,
  },
} = getFrontConfig();

const headerId = 'byl-header';
const searchAIId = 'vuethesearch';

/**
 * Save the header banner's custom properties in the Vue store
 */
function calculateCustomProperties() {
  let headerHeight = null;
  let headerPlusBannerHeight = null;
  let headerPlusBannerAndSearchHeight = null;

  const headerGroup = document.querySelector('.header-group');
  if (headerGroup !== null) {
    const header = document.getElementById(headerId);
    const searchAI = document.getElementById(searchAIId);
    headerHeight = searchAI && isEnabledInFront
      ? header.offsetHeight + searchAI.offsetHeight
      : header.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`,
    );
    document.documentElement.style.setProperty(
      '--header-height-not-search',
      `${header.offsetHeight}px`,
    );
    headerPlusBannerHeight = headerGroup.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-total-height',
      `${headerPlusBannerHeight}px`,
    );
    const search = document.querySelector('.the-search--show .the-search__form');
    headerPlusBannerAndSearchHeight = search && !isEnabledInFront
      ? Math.round(headerPlusBannerHeight + search.offsetHeight)
      : headerPlusBannerHeight;
    document.documentElement.style.setProperty(
      '--header-total-height-with-search',
      `${headerPlusBannerAndSearchHeight}px`,
    );

    const logo = headerGroup.querySelector('.logo__image');
    document.documentElement.style.setProperty(
      '--header-logo-width',
      `${logo.offsetWidth}px`,
    );
  }

  store.commit(types.header.setHeights, {
    header: headerHeight,
    headerPlusBanner: headerPlusBannerHeight,
    headerPlusBannerAndSearch: headerPlusBannerAndSearchHeight,
  });
}

const handleResize = debounce(calculateCustomProperties, 500);

/**
 * Load the header banner's content
 */
function loadHeader() {
  // This listener won't dissapear
  /* eslint-disable listeners/no-missing-remove-event-listener */
  window.addEventListener('resize', handleResize, { passive: true });
  document.addEventListener('header:calculateCustomProperties', handleResize);
  calculateCustomProperties();
}

/**
 * Initializes the header banner container
 */
function initializeHeaderBanner() {
  const headerBannerStatus = window.sessionStorage.getItem(
    'hide_header_banner',
  );
  const isValidContainerPage = document.getElementsByClassName('page--home')[0]
    || document.querySelector(
      '.page[data-action="Product-Show"]',
    )
    || document.querySelector(
      '.page[data-action="Search-Show"]',
    );
  if ((!headerBannerStatus || headerBannerStatus < 0) && isValidContainerPage) {
    const sliderTopBanner = document.querySelector(
      '.header-banner .html-slot-container div',
    );
    if (sliderTopBanner) {
      $('.header-banner .btn-close').on('click', () => {
        $('.header-banner').hide();
        calculateCustomProperties();
        window.sessionStorage.setItem('hide_header_banner', '1');
      });
      $('.header-banner').show();
      calculateCustomProperties();
    }
  } else {
    $('.header-banner').hide();
    calculateCustomProperties();
  }
}

module.exports = () => {
  initializeHeaderBanner();
  loadHeader();
};
